<template>
    <router-view></router-view>
</template>

<script>
export default {
    metaInfo: {
        title: "Login"
    },

    components: {},

    mounted() {
    },

    props: {},

    data: function() {
        return {
        };
    },

    watch: {},

    computed: {},

    methods: {}
};
</script>
